import {
    pxToRem,
    pxArrayToRem,
    paginationItemClassName,
    paginationClassName,
    dividerClassName,
    paginationItemsPerPageClassName,
    paginationSlotClassNames,
    paginationItemCounterClassName,
} from '@archipro-design/aria';

import type { StyleRule } from '@archipro-design/aria';

export const PaginationWrapper: StyleRule = ({ theme }) => ({
    padding: pxArrayToRem([0, 18]),

    [`& .${paginationClassName}`]: {
        width: '100%',
        [`& .${paginationItemClassName}`]: {
            display: 'flex',
        },
    },

    [theme.screen.laptop]: {
        [`& .${paginationClassName}`]: {
            width: 'auto',
            [`& .${paginationSlotClassNames.list}`]: {
                marginBottom: pxToRem(25),
            },
            [`& .${paginationItemCounterClassName}`]: {
                margin: 0,
            },
        },

        [`& .${dividerClassName}`]: {
            display: 'none',
        },

        [`& .${paginationItemsPerPageClassName}`]: {
            display: 'none',
        },
    },
});
